import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IonicModule } from '@ionic/angular'
import { TranslocoModule } from '@jsverse/transloco'

import { UnifiedSearchComponent } from './unified-search.component'

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TranslocoModule],
  declarations: [UnifiedSearchComponent],
  exports: [UnifiedSearchComponent],
})
export class UnifiedSearchModule {}
